import * as React from 'react'
import {Chosen, onChangeHandler} from "../../../lib/sbhtml/chosen";
import {Option} from "react-select";
import {SingleBox as Select} from "../../../lib/sbhtml/select";
import {isOpenedStatus, isSentStatus, Message, MessageId, OpenedStatus, SentStatus} from "./data";
import {toStrings} from "../../../lib/utils";
import {AlwaysPost} from "../../../lib/sbhtml/input";

export type CommunicationsMessageFiltersProps = ValueProps & CallbackProps

export type ValueProps = {
	messages: Message[]
	selectedMessages: MessageId[]
	sentStatus: SentStatus
	openedStatus: OpenedStatus
}

export type CallbackProps = {
	setMessages: (messages: MessageId[]) => void
	setSentStatus: (sentStatus: SentStatus) => void
	setOpenedStatus: (openedStatus: OpenedStatus) => void
}

export const CommunicationsMessageFilters = (props: CommunicationsMessageFiltersProps) => {
	const options = mapMessagesToOptions(props.messages, props.selectedMessages)

	return <div>
		<AlwaysPost name="cm_messages" value={toStrings(props.selectedMessages).join()}/>
		<AlwaysPost name="cm_sentStatus" value={props.sentStatus}/>
		<AlwaysPost name="cm_openedStatus" value={props.openedStatus}/>
		<label>
			<p>Messages: </p>
			<Chosen
				multi={true}
				removeSelected={true}
				value={props.selectedMessages}
				options={options}
				onChange={onChangeHandler(props.setMessages)}
				placeholder="Select messages..."
				style={{width: '600px'}}
			/>
		</label>
		<label>
			<p>Sent Status: </p>
			<Select
				value={props.sentStatus}
				onChange={ss => props.setSentStatus(isSentStatus(ss) ? ss : 'any')}
				enabled={props.selectedMessages.length > 0}
			>
				<option value="any">Any</option>
				<option value="sent">Sent</option>
				<option value="unsent">Unsent</option>
			</Select>
		</label>
		<label>
			<p>Opened Status: </p>
			<Select
				value={props.openedStatus}
				onChange={os => props.setOpenedStatus(isOpenedStatus(os) ? os : 'any')}
				enabled={props.selectedMessages.length > 0}
			>
				<option value="any">Any</option>
				<option value="opened">Opened</option>
				<option value="unopened">Unopened</option>
			</Select>
		</label>
	</div>
}

const mapMessagesToOptions = (messages: Message[], selectedMessages: MessageId[]):Option<MessageId>[] => {
	return messages.map((m: Message) => {
		return {
			value: m.id,
			label: m.title,
			disabled: selectedMessages.find((sm) => sm == m.id) !== undefined
		}
	});
}



// WEBPACK FOOTER //
// ./src/contacts/querybuilder-filters/communications-message/presentation.tsx